import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Alexa Kreizinger --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Annotations";
const frontMatter = {
  "title": "Annotations",
  "description": "Configure Kubernetes annotations in Chronosphere Telemetry Pipeline."
};
import {Tabs} from '@/components';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h1: "h1",
    p: "p",
    pre: "pre",
    span: "span",
    ..._provideComponents(),
    ...props.components
  };
  if (!Tabs) _missingMdxReference("Tabs", false);
  if (!Tabs.Tab) _missingMdxReference("Tabs.Tab", true);
  return <>{}{"\n"}<_components.h1>{"Annotations"}</_components.h1>{"\n"}<_components.p><_components.a href="https://kubernetes.io/docs/concepts/overview/working-with-objects/annotations/">{"Annotations"}</_components.a>{"\nlet you attach custom metadata to Telemetry Pipeline resources. These annotations won’t\naffect Telemetry Pipeline’s behavior."}</_components.p>{"\n"}<Tabs><Tabs.Tab label="Pipeline CLI" id="annotations-cli"><_components.p><_components.a href="/pipeline-cli">{"Pipeline CLI"}</_components.a>{" lets you specify tolerations for new resources.\nHowever, you can’t use Pipeline CLI to add or modify tolerations for an existing\nresource."}</_components.p><_components.p>{"When you create a new resource, add the "}<_components.code>{"--annotations"}</_components.code>{" flag to your operation,\nand include an annotations string."}</_components.p><_components.p>{"The string that specifies your annotations must follow this syntax:"}</_components.p><_components.pre tabIndex="0" data-language="copy" data-word-wrap=""><_components.code><_components.span><_components.span>{"annotation1=value1,annotation2=value2"}</_components.span></_components.span></_components.code></_components.pre></Tabs.Tab><Tabs.Tab label="Helm" id="annotations-helm"><_components.p>{"Helm lets you add annotations to new resources, and add or modify annotations\nfor existing resources."}</_components.p><_components.p>{"To do so, add the following key/value pair to your Helm chart:"}</_components.p><_components.pre tabIndex="0" data-language="yaml" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"calyptiaAnnotations"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"STRING\""}</_components.span></_components.span></_components.code></_components.pre><_components.p>{"Replace "}<_components.em><_components.code>{"STRING"}</_components.code></_components.em>{" with the string that specifies your annotations."}</_components.p><_components.p>{"The string that specifies your annotations must follow this syntax:"}</_components.p><_components.pre tabIndex="0" data-language="copy" data-word-wrap=""><_components.code><_components.span><_components.span>{"annotation1=value1,annotation2=value2"}</_components.span></_components.span></_components.code></_components.pre></Tabs.Tab></Tabs></>;
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/pipeline-configure/kubernetes/annotations',
  {"filePath":"pages/pipeline-configure/kubernetes/annotations.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)